import { render } from "./WarehouseUpdate.vue?vue&type=template&id=51340bb3"
import script from "./WarehouseUpdate.vue?vue&type=script&lang=js"
export * from "./WarehouseUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Projects/Vue/one-invoice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__